"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipFlyoutContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _core = require("@emotion/core");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _TooltipContainer = require("../components/TooltipContainer");
var _tooltipTheme = require("../tooltipTheme");
const slideTransitionStyles = {
  top: {
    transform: "translateY(4px)"
  },
  bottom: {
    transform: "translateY(-4px)"
  },
  left: {
    transform: "translateX(4px)"
  },
  right: {
    transform: "translateX(-4px)"
  }
};
/**
 * This component's job is to apply the correct animations and border radius to the Tooltip.
 */
const TooltipFlyoutContainer = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    enterDirection,
    showTransition,
    transitionStatus,
    ...props
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const slideTransition = `transform ${_tooltipTheme.tooltipTheme.motion.slide(themeMode)}`;
  const opacityTransition = `opacity ${_tooltipTheme.tooltipTheme.motion.opacity(themeMode)}`;
  return /*#__PURE__*/_react.default.createElement(_core.ClassNames, null, _ref2 => {
    let {
      css
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_TooltipContainer.TooltipContainer, (0, _extends2.default)({}, props, {
      ref: ref,
      className: css({
        opacity: transitionStatus === "entered" ? 1 : 0,
        transform: transitionStatus === "entering" && enterDirection !== "auto" ? slideTransitionStyles[enterDirection].transform : "translateY(0) translateX(0)",
        // Always show opacity, slide transition nees to happen AFTER the first popper update.
        transition: `${opacityTransition}, ${showTransition ? slideTransition : ""}`
      })
    }), children);
  });
});
exports.TooltipFlyoutContainer = TooltipFlyoutContainer;
TooltipFlyoutContainer.displayName = "TooltipFlyoutContainer";
//# sourceMappingURL=TooltipFlyoutContainer.js.map